module.exports = __webpack_public_path__ + "static/media/x-with-circle.3a1bebe1.svg";